import React from 'react';

import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import {HeroSoundPlayer} from './SoundPlayer.js';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import {renderContentfulRichContent, mixpanel} from "./App.js";
import colors from './colors.js';
import covidBackground from './covid_background.jpg';

const useStyles = makeStyles(theme => ({
  intro: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    position: "relative",
  },
  backgroundImage: {
    width: "100%",
    height: "100%",
    objectPosition: "50% 50%",
    objectFit: "cover",
    position: "absolute",
    top: 0,
    left: 0,
    paddingTop: theme.spacing(8),
  },
  backgroundScreen: {
    width: "100%",
    height: "100%",
    position: "absolute",
    background: colors.pink,
    opacity: 0.5,
  },
  introText: {
    zIndex: 1,
    marginTop: theme.spacing(16),
    color: colors.darkBlue,
    flexDirection: "column",
    display: "flex",
    [theme.breakpoints.only('xs')]: {
      width: "100vw",
    },
  },
  heroText: {
    flexGrow: 1,
  },
  heroSubtext: {
    paddingTop: theme.spacing(2),
    color: colors.darkBlue,
    "& a": {
      color: "inherit",
      textDecoration: "underline",
      "&:hover": {
        color: colors.darkerBlue
      }
    }
  },
  scrollButtonContainer: {
    cursor: "default",
    paddingLeft: 0,
    color: colors.darkBlue,
    alignItems: "center",
    display: "flex",
  },
  introContainer: {
    height: "100%",
  },
  scrollButtonIcon: {
    marginRight: theme.spacing(2),
    fill: colors.darkBlue,
    height: theme.spacing(5),
    width: theme.spacing(5),
    cursor: "pointer",
    "&:active": {
      fill: colors.blue
    },
    "&:hover": {
      fill: colors.darkerBlue
    }
  },
}));


export const Landing = (props) => {
  const classes = useStyles();
  return (
    <div className={classes.intro}>
      <img className={classes.backgroundImage} src={covidBackground} />
      <div className={classes.backgroundScreen} />
      <Grid container className={classes.introContainer} justify="center">
        <Grid className={classes.introText} item xs={11} sm={5}>
          <div className={classes.heroText}>
            <Typography align="left" variant="h2">
              <i>the</i> NOCTURNISTS:
            </Typography>
            <Typography align="left" variant="h3">
              stories from a pandemic
            </Typography>
            <Typography className={classes.heroSubtext} align="left" variant="subtitle1">
                {props.landingCopy.landingTitleBody?.content.map(node => renderContentfulRichContent(node))}
            </Typography>
            <div className={classes.latestEpisode}>
              <HeroSoundPlayer
                key={props.landingCopy.latestEpisodeLink}
                title={props.landingCopy.latestEpisodeCopy}
                streamUrl={props.landingCopy.latestEpisodeLink}
                onPlay={() => {
                  mixpanel.track("play_podcast", {copy: props.landingCopy.latestEpisodeCopy});
                }}
                onPause={() => {
                  mixpanel.track("pause_podcast", {copy: props.landingCopy.latestEpisodeCopy});
                }}
              />
            </div>
            <div
              className={classes.scrollButtonContainer}
              item
              xs={12}
              onClick={props.handleScrollToMap}
            >
              <KeyboardArrowDownIcon className={classes.scrollButtonIcon} />
              <Typography align="left" variant="h6">
                {props.landingCopy.scrollToDiariesCopy}
              </Typography>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  )
}
